import script from "./CombinationIncome.vue?vue&type=script&setup=true&lang=js"
export * from "./CombinationIncome.vue?vue&type=script&setup=true&lang=js"

import "./CombinationIncome.vue?vue&type=style&index=0&id=7bbab50a&scoped=true&lang=scss"

import exportComponent from "/Users/yangxu/work/js_celue-zuhe_src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bbab50a"]])

export default __exports__